module.exports = __webpack_public_path__ + "media/images/shared/delivery/nv-express-4c87f1b8e0fe90435437d4aea05d7eb7.gif";